export { default as EntitlementsService } from './entitlements-service';